var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.001 31"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.795 5.172L26.829.206a.7.7 0 00-.993 0l-3 3-11.371 11.37a.7.7 0 00-.192.357l-1.258 6.225a.7.7 0 00.689.842.682.682 0 00.139-.014l6.225-1.258a.7.7 0 00.357-.192l14.37-14.37a.7.7 0 000-.993zm-12.88 11.887l-1.49-1.49 8.394-8.394 1.49 1.49zm-2.483-2.483l-1.49-1.49 8.394-8.394 1.49 1.49zm.15 4.817l-4.98 1.007 1.006-4.98 1.341-1.341 3.974 3.974zm11.72-11.721l-3.973-3.973 2-2 3.973 3.973z",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 661",
    d: "M27.798 13.202a.789.789 0 00-.789.789v13.673a1.761 1.761 0 01-1.759 1.759H3.337a1.761 1.761 0 01-1.759-1.759V6.77a1.761 1.761 0 011.759-1.759h13.676a.789.789 0 000-1.578H3.337A3.342 3.342 0 000 6.77v20.894a3.341 3.341 0 003.337 3.337H25.25a3.341 3.341 0 003.337-3.337V13.991a.789.789 0 00-.789-.789z",
    fill: "#f60"
  }))));
}

export default __webpack_public_path__ + "c50ec45bb8a94304d94d1084eb0ee732.svg";
export { SvgEdit as ReactComponent };